var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.772 22.904c-.004-2.013-.688-3.98-1.965-5.653-1.277-1.673-3.09-2.976-5.211-3.744.198-.502.35-1.018.453-1.541v-.067c.05-.252.087-.51.113-.769v-.123c.023-.261.038-.523.038-.792.008-2.647-1.159-5.193-3.253-7.097C17.852 1.213 14.994.099 11.98.013 8.965-.073 6.03.875 3.8 2.656 1.568 4.436.215 6.91.026 9.552c0 0-.018-.023-.026-.043V29.4c.001.981.446 1.922 1.237 2.616.79.695 1.863 1.085 2.982 1.086h13.973c2.902-.006 5.697-.966 7.831-2.692 2.135-1.726 3.455-4.091 3.7-6.63.026-.271.037-.54.037-.808 0 0 .012-.047.012-.067z",
    fill: "#D9DAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.17 33.105c6.406 0 11.599-4.558 11.599-10.18s-5.193-10.18-11.598-10.18c-6.406 0-11.599 4.558-11.599 10.18s5.193 10.18 11.599 10.18z",
    fill: "url(#logo_svg__paint0_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.615 20.36c6.406 0 11.598-4.558 11.598-10.18S18.021 0 11.615 0C5.21 0 .017 4.558.017 10.18S5.21 20.36 11.615 20.36z",
    fill: "url(#logo_svg__paint1_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(126.548 11.44 12.554) scale(30.6354 32.8786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D30CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187,
    stopColor: "#9D30CA",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#9D30CA",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#9D30CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_svg__paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(148.373 12.136 4.782) scale(31.0099 28.6642)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7063FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#637CFF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#63DAFF",
    stopOpacity: 0
  })))));
}

export default SvgLogo;